export default "__VITE_ASSET__B1vjJ$3E__"